import { listSupplier } from 'api/mdl04'
import {
  creditAccounts,
  fullfilmentPlanByDelivery,
  listChannels,
} from 'api/mdl11'
import { fullfilmentPlan } from 'api/mdl22'

export const fullfilmentPlanAction = () => {
  return async dispatch => {
    dispatch({ type: 'LOADING_FULLFILMENT', payload: true })

    try {
      const res = await fullfilmentPlan()
      const { data, status } = res
      if (status === 200 && data) {
        dispatch({ type: 'FULLFILMENT_RESPONSE', payload: data })
        return data
      } else {
        dispatch({
          type: 'FULLFILMENT_RESPONSE',
          payload: { message: 'ERROR' },
        })
        return { message: 'ERROR' }
      }
    } catch (err) {
      console.error('Error fullfilmentPlanAction', err)
      return err
    }
  }
}

export const fetchFullfilmentPlanByDelivery = payload => {
  return async dispatch => {
    dispatch({ type: 'LOADING_FULLFILMENT', payload: true })

    try {
      const res = await fullfilmentPlanByDelivery(payload)
      const { data, status } = res
      if (status === 200 && data) {
        dispatch({ type: 'FULLFILMENT_RESPONSE', payload: data })
        return data
      } else {
        dispatch({
          type: 'FULLFILMENT_RESPONSE',
          payload: { message: 'ERROR' },
        })
        return { message: 'ERROR' }
      }
    } catch (err) {
      console.error('Error getChannelsAction', err)
      dispatch({ type: 'FULLFILMENT_RESPONSE', payload: { message: 'ERROR' } })
      return { message: 'ERROR' }
    }
  }
}

export const supplierAction = products => {
  return async dispatch => {
    dispatch({ type: 'LOADING_SUPPLIER', payload: true })
    try {
      const response = await listSupplier(products)
      const { data, status } = response
      if (status === 200 && data?.Data && data.Data.length > 0) {
        dispatch({ type: 'SUPPLIER_RESPONSE', payload: data.Data })
        dispatch({ type: 'LOADING_SUPPLIER', payload: false })
        return data.Data
      } else {
        dispatch({
          type: 'SUPPLIER_RESPONSE',
          payload: [],
        })
        dispatch({ type: 'LOADING_SUPPLIER', payload: false })
        return []
      }
    } catch (err) {
      console.error('Error getChannelsAction', err)
      dispatch({
        type: 'SUPPLIER_RESPONSE',
        payload: [],
      })
      dispatch({ type: 'LOADING_SUPPLIER', payload: false })
      return []
    }
  }
}

export const creditAccountsAction = ({ customerId, companyId }) => {
  return async dispatch => {
    dispatch({ type: 'LOADING_CREDIT_ACCOUNTS', payload: true })
    try {
      const response = await creditAccounts({ customerId, companyId })
      const { data, status } = response
      if (status === 200 && Array.isArray(data?.Data)) {
        dispatch({ type: 'CREDIT_ACC_RESPONSE', payload: data })
        return data
      } else {
        dispatch({
          type: 'CREDIT_ACC_RESPONSE',
          payload: { message: 'ERROR' },
        })
        return { message: 'ERROR' }
      }
    } catch (err) {
      console.error('Error getChannelsAction', err)
      dispatch({
        type: 'CREDIT_ACC_RESPONSE',
        payload: { message: 'ERROR' },
      })
      return { message: 'ERROR' }
    }
  }
}

export const fetchListChannels = () => async () => {
  try {
    const response = await listChannels()
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    console.error('Error getChannelsAction', err)
    return err
  }
}
